import { render, staticRenderFns } from "./PayPalCasesTableUser.vue?vue&type=template&id=d803d8ec&scoped=true"
import script from "./PayPalCasesTableUser.vue?vue&type=script&lang=js"
export * from "./PayPalCasesTableUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d803d8ec",
  null
  
)

export default component.exports